import {Component} from '@angular/core';

@Component({
  selector: 'invalid-voucher',
  templateUrl: './invalid-voucher.component.html',
  styleUrls: ['./invalid-voucher.component.css'],
})
export class InvalidVoucherComponent {

}
